import React from "react";
import FontAwesome from "react-fontawesome";
import CommonTable from '../../common/CommonTable';
import TableToolbar from '../../submit_claims/claims_table/TableToolbar'
import { kinetik_api_url, mapDbClaimsToTableRow, mapCSVtoTable} from "~/app/utilities";
import _ from 'underscore';
import axios from 'axios';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { addViewClaims, isRecentBatch } from "../../submit_claims/upload/actions";
import {setStatusCardIndex} from '../status_card_view/actions';
import moment from 'moment'


class StatusCard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      claims: null,
      showTable:false,
      searchTerm:"",
    };
  }

  getBatchClaims = (batch) => {
    const token = localStorage.getItem('authToken');
    axios
      .post(kinetik_api_url + "/batch/claims", {
        claim_ids: batch.claims, token
      })
      .then(response => {
        //const mappedData = _.map(response.data, mapDbClaimsToTableRow);
        const mappedDataAllFields = _.map(response.data,mapDbClaimsToTableRow)
         mapCSVtoTable(mappedDataAllFields);
        this.props.addViewClaims(mappedDataAllFields);
        this.props.isRecentBatch(false);
        this.setState({ showTable:true})
      })
      .catch(err => {
        console.log("/batch/claims error:", err);
      });
  }

 
  render() {
    const batch = Object.assign({}, this.props.batch);
    const mappedDataTableFields = mapCSVtoTable(this.props.view_claims);
    return (
      <div>
        {this.renderStatusCard(batch)}
        <div className ="status-box">
          {this.state.showTable &&
            <div className="box table-position">
            
            <div className="table-toolbar">
              <TableToolbar
                onSearchTermChange={term => this.setState({ searchTerm: term })}
                renderedLocation={"batch_status"}
              />
            </div>
            <div className="box-content">
              <CommonTable
                data={mappedDataTableFields}
                searchTerm={this.state.searchTerm}
              />
  
            </div>
          </div>
          }
        </div>

      </div>

    );
  }
  
  handleExpand=(batch)=>{
    const cardIndex = this.props.index;
    if(!this.state.showTable){
      this.getBatchClaims(batch);
      this.props.setStatusCardIndex(cardIndex);
    }else{ //when show table is true
      this.props.setStatusCardIndex(-1);
      this.setState({showTable:false})
    }
  }



  renderStatusCard = (batch) => {

    return (
      <div className="status-card ">
        <div className="container">
          <div className="row">
            <div className="col-sm-2 vertical-center">
              <FontAwesome className="icon-expand" name={(!this.state.showTable)?"plus-circle":"minus-circle"} onClick={() => this.handleExpand(batch)} />
              {batch.date_submitted.substring(0, 10)}
            </div>
            <div className="col-sm-2 vertical-center">
              {batch.payerid}
            </div>
            <div className="col-sm-3 vertical-center">
              {batch.file_name}
            </div>
            <div className="col-sm-2">
              <p>Acknowledged: {batch.acknowledged_count.length}</p>
              <p className={(batch.rejected_count.length!==0)?"red":""}>Rejected: {batch.rejected_count.length}</p>
              <p>Ready: {batch.ready_count.length}</p>
            </div>
            <div className="col-sm-3 last-updated-col">
            <p> </p>  
              <p>{moment(batch.last_updated).format('llll')}</p>  
              {/* <p>{moment(batch.last_updated.substring(0, 10)).format('lll')}</p>
              <p>{moment(batch.last_updated.substring(11, 19)).format('lll')}</p> */}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    view_claims: state.submitClaims.view_claims,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      addViewClaims,isRecentBatch,setStatusCardIndex
    },
    dispatch
  );
}

export default connect(mapStateToProps,mapDispatchToProps)(StatusCard);



// WEBPACK FOOTER //
// ./src/app/batch_status/status_card/Status_Card.js